import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'src/app/shared/validators/no-whitespace-validator';
import {
  CHEMICAL_EXPOSURE_MAX_LENGTH,
  IChemicalExposureDefaults,
} from '../models/chemical-exposure.model';

function toExposedAtDate(value?: Date | string): Date {
  if (value instanceof Date) {
    return value;
  }
  if (value) {
    return new Date(value);
  }
  return new Date();
}

export class ChemicalExposureForm extends FormGroup {
  readonly exposureDurationId = this.get('exposureDurationId') as FormControl<string>;
  readonly exposurePlacement = this.get('exposurePlacement') as FormControl<number | null>;
  readonly exposureLocation = this.get('exposureLocation') as FormControl<string>;
  readonly safetyDataSheetConfirmed = this.get('safetyDataSheetConfirmed') as FormControl<boolean>;
  readonly substanceName = this.get('substanceName') as FormControl<string>;
  readonly manufacturerName = this.get('manufacturerName') as FormControl<string>;
  readonly exposedAt = this.get('exposedAt') as FormControl<Date>;
  readonly exposedUserIds = this.get('exposedUserIds') as FormControl<string[]>;

  constructor(
    defaults?: IChemicalExposureDefaults,
    readonly fb: FormBuilder = new FormBuilder()
  ) {
    super(
      fb.group({
        exposureDurationId: [defaults?.exposureDurationId ?? '', Validators.required],
        exposurePlacement: [defaults?.exposurePlacement ?? null, Validators.required],
        exposureLocation: [
          defaults?.exposureLocation ?? '',
          [
            Validators.required,
            noWhitespaceValidator,
            Validators.maxLength(CHEMICAL_EXPOSURE_MAX_LENGTH.exposureLocation),
          ],
        ],
        safetyDataSheetConfirmed: [
          defaults?.safetyDataSheetConfirmed ?? false,
          Validators.requiredTrue,
        ],
        substanceName: [
          defaults?.substanceName ?? '',
          [Validators.required, Validators.maxLength(CHEMICAL_EXPOSURE_MAX_LENGTH.substanceName)],
        ],
        manufacturerName: [
          defaults?.manufacturerName ?? '',
          Validators.maxLength(CHEMICAL_EXPOSURE_MAX_LENGTH.manufacturerName),
        ],
        exposedAt: [toExposedAtDate(defaults?.exposedAt), Validators.required],
        exposedUserIds: [defaults?.exposedUserIds ?? [], Validators.required],
      }).controls
    );
  }
}
